import { PropTypes } from 'prop-types' 
import { EmptyFactors } from './EmptyFactor'
import { MFA } from '../mfaWizard/MFASteps'
import ConfirmMFAFactorResetModal from '../editProfileUI/ConfirmMFAFactorResetModal'
import { useState } from 'react'

export const Factors = ( { webId, factors, onResetFactor, onResetAllFactors, mfaIsOnForUser, onFactorAddClick, onHandleUpdate, config, showErrorMessage, loginEmailFocusClick }  ) => {
    const [ modalOpen, setModalOpen ] = useState( false ) 
    const [ loading, setLoading ] = useState( false )
    const [ resetFactorId, setResetFactorId ] = useState( null )
    let mobileOrder='order-3'
    let emailOrder='order-5' 
    
    if( factors.length && !factors.some( f=>f.factorType === MFA.factorType.sms ) ){
        mobileOrder='order-5'
        emailOrder='order-3' 
    }

    const openConfirmationModal=( event, factorId )=>{
        if( event ) event.preventDefault()
        setModalOpen( true )
        setResetFactorId( factorId )
    }

    const closeConfirmationModal=( )=>{
        setModalOpen( false )
        setResetFactorId( null )
    }

    const handleFactorReset=( event, factorId )=>{
       if( event ) event.preventDefault()

        closeConfirmationModal( )
        
        if( factorId )  return onResetFactor( factorId )
        
        return onResetAllFactors()
    }

     const triggerLoginEmailFocus = ( event ) => { 
        if( event ) event.preventDefault()
        loginEmailFocusClick( )
     }
    const handleModalOpenClose=( open, factorId )=>{
       if( open ) openConfirmationModal( factorId )
       else closeConfirmationModal()
    } 

    const formatPhoneNumber=( phoneNumberString )=> {
        let phone 
        if ( !phoneNumberString ) return null

        if( phoneNumberString?.startsWith( '+1' ) ){
             phone= phoneNumberString.replace( '+1','' )
        }else{
            phone=phoneNumberString
        }
         const cleaned = ( '' + phone ).replace( /\D/g, '' )
         const match = cleaned.match( /^(1|)?(\d{3})(\d{3})(\d{4})$/ )
         if ( match ) {
             const intlCode = ( match[ 1 ] ? '+1 ' : '' )
             return [ intlCode, '(', match[ 2 ], ') ', match[ 3 ], '-', match[ 4 ] ].join( '' )
         }
         return null
     }

     const handleFactorAddClick=(  selectedFactor )=>{ 
        onFactorAddClick( selectedFactor )
        setLoading( false ) 
     } 

    const smsFactor = factors.find( f=> f.factorType === MFA.factorType.sms )
    const emailFactor = factors.find( f=> f.factorType === MFA.factorType.email  )
    const phone = formatPhoneNumber( smsFactor?.profile?.phoneNumber )
    const email = emailFactor?.profile?.email
    const bothFactorsAreEnrolled = smsFactor && emailFactor
    
     const handleEditClick = ( event ) => { 
        if( event ) event.preventDefault() 
        onHandleUpdate( smsFactor?.id ) 
     }

    const renderPhone=()=>{
        if( phone ){
            
        return  <span className={ mobileOrder+' w-100' }>      
            <div className='factors-row'><strong tabIndex='0'  aria-label={ phone } >{phone}</strong> <span className="links"> <button tabIndex={ 0 } id='dt-mfa-edit' className='add-factor u-btn-clear' aria-label='Edit mobile number for verification' onClick = { ( e ) => {  handleEditClick( e ) } } >Edit</button>
                {
                    bothFactorsAreEnrolled && <>| <button  id='dt-mfa-remove' tabIndex='0' data-testid="smsRemove" className='sms-remove u-btn-clear' aria-label='Remove SMS verification' onClick = { ( e ) => {  handleFactorReset( e, smsFactor?.id  ) } } >Remove</button></>
                } </span></div>
        </span>
        }
        else{
            return <EmptyFactors type="Phone" factor= { MFA.FACTORS.SMS } onAddClick={ ( factorValue ) => handleFactorAddClick( factorValue ) }></EmptyFactors>
        }
    }

    const renderMail=()=>{
        if( email ){
        return  <span className={ emailOrder+' w-100' }>      
            <div className='factors-row'><strong tabIndex='0' aria-label={ email } className='email'>{email}</strong> 
                {
                    bothFactorsAreEnrolled && <button tabIndex={ 0 } id='dt-mfa-remove' data-testid="emailRemove"  className='email-remove u-btn-clear' aria-label='Remove Email verification' onClick = { ( e ) => {  handleFactorReset( e, emailFactor?.id  ) } } >Remove</button> 
                }
            </div>
            <div className='email-info'><span  tabIndex='0'>Edit login email </span><a href='' tabIndex='0' className='above-link' aria-label='Directs you to use the email field at the top of the form to change your email address' onClick={ ( e ) => triggerLoginEmailFocus( e ) }><strong><u data-testid="above" >above</u></strong></a></div>
        </span>
        }
        else{
            return <EmptyFactors type="Email" factor= { MFA.FACTORS.EMAIL } onAddClick={ ( factorValue ) => handleFactorAddClick( factorValue ) }></EmptyFactors>
        }
    }

    const renderComponent=()=>{
        const mfaOnOff = mfaIsOnForUser ? 'ON' : 'OFF'
        return <>
            <div className='c-form-container c-form-container--box mb-5 adsec-container factors'>
                <div className='factors-row'> 
                    <span tabIndex='0' data-testid="twoFA" aria-label='Two-step verification is' >  Two-step verification is <strong aria-label={ mfaOnOff }  data-testid="twoFAOnOff">{mfaOnOff}</strong></span>
                    { mfaIsOnForUser && <a href='' id='dt-mfa-turnoff' data-testid="turnOff" tabIndex='0' className='turn-off' aria-label='Turn off' onClick = { ( e ) => { openConfirmationModal( e ) } } >Turn Off</a> }
                </div>
                <hr  className='divider order-1'/>        
                <div aria-label='You get verification codes at:' className="verification order-2" tabIndex='0' >You get verification codes at: </div>   
                { mobileOrder == 'order-3' && renderPhone()}
                { emailOrder == 'order-3' && renderMail()}
                <hr className='dashed-divider order-4'/>
                { mobileOrder == 'order-5' && renderPhone()}
                { emailOrder == 'order-5' && renderMail()}
            </div>
            <ConfirmMFAFactorResetModal
                open= { modalOpen }
                factorId = { resetFactorId }
                onSubmit = { ( factorIdValue ) => handleFactorReset( null, factorIdValue ) }
                handleModalOpenClose= { ( open, factorIdValue ) => handleModalOpenClose( open, factorIdValue ) }
            />
           
        </>
    }

return <>
    {renderComponent()}
    
</>
}

Factors.propTypes = {
    webId: PropTypes.string,
    factors: PropTypes.array.isRequired,
    onResetFactor: PropTypes.func, 
    onResetAllFactors: PropTypes.func, 
    mfaIsOnForUser: PropTypes.bool.isRequired,
    onFactorAddClick: PropTypes.func,
    showErrorMessage: PropTypes.func,
    onHandleUpdate: PropTypes.func,
    config: PropTypes.shape( { 
      userProfileDataViewModel : PropTypes.object,
      forgotPasswordUrl: PropTypes.string,
      logInApiUrl: PropTypes.string,
      disablePhoneNumber: PropTypes.bool,
      logOffUrl: PropTypes.string,
      contactUsUrl: PropTypes.string,
  } ),
  loginEmailFocusClick: PropTypes.func,
}